<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-ai`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.291 8.211C34.114 4.88 29.825 3.056 25.17 3.056h-.877l-.316.01c-9.013.338-15.986 8.054-15.908 17.84-.055.054-1.433 1.87-2.515 3.295-.575.757-1.066 1.404-1.23 1.618-.713.926-1.095 1.76-1.08 2.544.034 2.207 1.415 3.195 4.183 3.805l1.04.218.377 7.9.01.199c.14 1.981 1.826 3.571 3.819 3.571.215 0 6.356-.78 9.328-1.302v-4.178c-2.047.286-6.585.939-9.225 1.37l-.473-9.554-.002-.079a2.995 2.995 0 00-.047-.43 1.326 1.326 0 00-.202-.534c-.215-.294-.476-.498-.812-.498A67.94 67.94 0 019 28.482l-.274-.049-.1-.024a.83.83 0 01-.398-1.315c1.94-2.397 3.027-3.712 3.26-3.948.467-.463.596-.923.596-1.783 0-.102-.005-.192-.018-.331a2.213 2.213 0 01-.015-.195c-.064-3.71 1.255-6.99 3.64-9.61 2.393-2.634 5.689-4.106 9.285-4.134h.193l.313.004c7.167.168 12.62 5.96 12.712 13.606l-.003.297 4.052-.001V20.666c-.07-4.772-1.825-9.209-4.953-12.455zM40 41l-5.773-17H30.75L25 41h3.326l1.186-4.03h5.933L36.63 41H40zm4-17v17h-3V24h3zM30.51 34c1.251-4.465 1.9-6.799 1.947-7 .047.201.71 2.535 1.99 7H30.51z"/></svg>
</template>
<script>

export default {
  name: 'IconAi',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
